import { render, staticRenderFns } from "./VasionInput.vue?vue&type=template&id=18c049ea&scoped=true&"
import script from "./VasionInput.vue?vue&type=script&lang=js&"
export * from "./VasionInput.vue?vue&type=script&lang=js&"
import style0 from "./VasionInput.vue?vue&type=style&index=0&id=18c049ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c049ea",
  null
  
)

export default component.exports